import React, { useEffect, useRef, useState } from "react";
import { ROOT_URL } from "../../../../config/url";
import {
  useList,
  useProfile,
  useAction,
  useUnroll, useObject,
} from "@vokymlak/kabinet-ui";
import {useViewer} from "../../../../components/Viewer";
import {useParams} from "react-router-dom";
import {ROLE_ADMINISTRATOR, ROLE_DIRECTOR, ROLE_EMPLOYEE} from "../../../../config/constants";

function useTickets(props) {
  const { isCount, isArchive, isTopicNull, authorId, executorId } = props;
  const { ticketTopicUuid } = useParams();
  const { profile } = useProfile();
  const [status, setStatus] = useState("null");

  const [selectEmployee, setSelectEmployee] = useState(0);
  const changeSelectEmployee = (accountId) => {
    setSelectEmployee(Number(accountId));
  };

  const { viewer } = useViewer();

  const changeViewer = (image, mimeType) => {
    viewer(image, mimeType);
  };

  const {
    object: [object, setObject],
    update: [isUpdateObject, setIsUpdateObject, changeUpdateObject],
    params: [_apiUrlParamsObject, setApiUrlParamsObject],
  } = useObject({
    apiUrl: "/api/tickets/count",
    rootUrl: ROOT_URL,
  });

  const {
    list: [employees],
  } = useList({
    apiUrl: "/api/employees/list",
    rootUrl: ROOT_URL,
    urlParams: {
      roles: [ROLE_ADMINISTRATOR, ROLE_DIRECTOR, ROLE_EMPLOYEE],
    }
  });

  const {
    list: [types],
  } = useList({ apiUrl: "/api/ticket-types", rootUrl: ROOT_URL });

  const {
    list: [statuses],
  } = useList({ apiUrl: "/api/ticket-statuses", rootUrl: ROOT_URL });

  const {
    list: [topics],
  } = useList({ apiUrl: "/api/ticket-topics", rootUrl: ROOT_URL });

  const getUrlParams = () => {
    let params = null;
    if (isArchive) {
      params = {
        ...params,
        archive: isArchive,
      };
    }
    if (ticketTopicUuid) {
      params = {
        ...params,
        topic: ticketTopicUuid,
      };
    }
    if (isTopicNull) {
      params = {
        ...params,
        "no-topic": isTopicNull,
      };
    }
    if (authorId) {
      params = {
        ...params,
        "author": authorId,
      };
    }
    if (executorId) {
      params = {
        ...params,
        "executor": executorId,
      };
    }
    if (!!status && status !== "null") {
      params = {
        ...params,
        status: status,
      };
    }
    if (!!selectEmployee && selectEmployee !== 0) {
      params = {
        ...params,
        "executor": selectEmployee,
      };
    }
    return params;
  };

  const {
    list: [list, count, setList],
    update: [isUpdateList, setIsUpdateList, changeUpdate],
    page: [pageNumber, setPageNumber, pageLimit, setPageLimit],
    search: [searchQuery, setSearchQuery],
    setApiUrlParams,
  } = useList({
    apiUrl: "/api/tickets",
    rootUrl: ROOT_URL,
    isPagination: true,
    paginationLimit: 100,
    isSearch: true,
    urlParams: getUrlParams(),
  });

  const { unrolls, isUnroll, changeUnroll, changeAllUnroll } = useUnroll();

  useAction("tickets", () => (changeUpdate(), changeUpdateObject()));

  const inputSearchText = useRef(null);
  useEffect(() => {
    setPageNumber(1);
  }, [searchQuery]);

  useEffect(() => {
    setApiUrlParams({ ...getUrlParams() });
    setApiUrlParamsObject({ ...getUrlParams() });
  }, [isCount, isArchive, ticketTopicUuid, isTopicNull, authorId, executorId, status, selectEmployee]);

  const onChangeSearchText = () => {
    setSearchQuery(inputSearchText.current.value);
  };

  const changePage = (data) => {
    if (pageNumber !== data.currentPage) {
      setPageNumber(data.currentPage);
    }
  };

  return {
    profile,

    object,
    isUpdateObject,
    setIsUpdateObject,

    list,
    setList,
    count,

    pageNumber,
    pageLimit,
    setPageLimit,
    changePage,

    unrolls,
    isUnroll,
    changeUnroll,
    changeAllUnroll,

    setIsUpdateList,
    isUpdateList,

    // isArchive,
    // setIsArchive,

    inputSearchText,
    onChangeSearchText,
    searchQuery,

    changeViewer,

    isCount,
    isArchive,
    isTopicNull,
    ticketTopicUuid,
    authorId,
    executorId,

    types,
    statuses,
    employees,
    topics,

    setStatus,
    status,

    selectEmployee,
    changeSelectEmployee,
  };
}

export default useTickets;
